import { ReactNode, RefObject, useImperativeHandle, useRef } from 'react'
import { LandingPageWidget } from './widgets'

export type LandingPageToolsRef = {}

export interface LandingPageToolsProps {
	children: ReactNode
	ref: RefObject<LandingPageToolsRef | null>
}

export function LandingPageTools({ children, ref }: LandingPageToolsProps) {
	const containerRef = useRef<HTMLDivElement>(null)

	useImperativeHandle(ref, () => ({}), [])

	return (
		<LandingPageWidget
			globalTools={[]}
		>
			{({ widget }) => (
				<>
					<div ref={containerRef}>
						{children}
					</div>
					<div className="mt-4">
						{widget}
					</div>
				</>
			)}
		</LandingPageWidget>
	)
}
